import { setLoading } from "../../common/Loader/slice";
import requestUtil from "../../../helpers/requestUtil";
import {
    getLocationDropdownSuccess, getLocationDropdownError, getUserTypesSuccess,
    getUserTypesError, updateUserInfoSuccess, updateUserInfoError, forgotPasswordSuccess,
    forgotPasswordError, resetPasswordSuccess, resetPasswordError, setSaveButtonDisabled, setLoadingFlagDecrement, setLoadingFlagIncrement
} from "./slice";

export function getLocationDropdownList(url, employerId) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Locations/get-location-list-for-dropdown-by-employerid/${employerId}`, "GET",)
        //     .then((response) => {
        //         dispatch(getLocationDropdownSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getLocationDropdownError('Please add at least one location'));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        // dispatch(setLoading(true));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Locations/get-location-list-for-dropdown-by-employerid/${employerId}`, "GET",)
            dispatch(getLocationDropdownSuccess(response));
        } catch (error) {
            dispatch(getLocationDropdownError('Please add at least one location'));
        }
        // dispatch(setLoading(false));
        finally {
            dispatch(setLoadingFlagDecrement())
        }

    };
}

export function getUserTypes(url) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/EmployerUsers/getusertypes`, "GET")
        //     .then((response) => {
        //         dispatch(getUserTypesSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getUserTypesError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        // dispatch(setLoading(true))
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/EmployerUsers/getusertypes`, "GET");
            dispatch(getUserTypesSuccess(response))
        } catch (error) {
            dispatch(getUserTypesError(error.message));
        }
        // dispatch(setLoading(false))
        finally {
            dispatch(setLoadingFlagDecrement())
        }

    };
}

export function updateEployerUser(url, userInfo) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/EmployerUsers/updateemployeruser`, "POST", userInfo)
        // .then((response) => {
        //         dispatch(updateUserInfoSuccess('update'));
        //     }).catch((error) => {
        //         dispatch(updateUserInfoError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/EmployerUsers/updateemployeruser`, "POST", userInfo)
            dispatch(updateUserInfoSuccess('update'))
        } catch (error) {
            dispatch(updateUserInfoError(error.message));
        }
        finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export function addEployerUser(url, userInfo) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // dispatch(setSaveButtonDisabled(true));
        // requestUtil(`${url}/EmployerUsers/addemployeruser`, "POST", userInfo)
        // .then((response) => {
        //         dispatch(updateUserInfoSuccess('add'));
        //         dispatch(setSaveButtonDisabled(false))
        //     }).catch((error) => {
        //         dispatch(updateUserInfoError(error.message));
        //         dispatch(setLoading(false));
        //         dispatch(setSaveButtonDisabled(false))
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        dispatch(setSaveButtonDisabled(true));
        try {
            const response = await requestUtil(`${url}/EmployerUsers/addemployeruser`, "POST", userInfo)
            dispatch(updateUserInfoSuccess('add'));
        } catch (error) {
            dispatch(updateUserInfoError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
            dispatch(setSaveButtonDisabled(false))
        }
    };
}

export function forgotPassword(url, email) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        requestUtil(`${url}/Authenticate/employer-forgot-password/${email}/${window.location.hostname}`, "POST", {})
            .then((response) => {
                dispatch(forgotPasswordSuccess(response.message));
            }).catch((error) => {
                dispatch(forgotPasswordError(error.message));
                dispatch(setLoading(false));
            });
        dispatch(setLoading(false));
    };
}

export function resetPassword(url, emailInfo) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        requestUtil(`${url}/Authenticate/emp-account-reset-password`, "POST", emailInfo)
            .then((response) => {
                dispatch(resetPasswordSuccess("Password changed successfully"));
            }).catch((error) => {
                dispatch(resetPasswordError(error.message));
                dispatch(setLoading(false));
            });
        dispatch(setLoading(false));
    };
}